module.exports = "/next-static/_next/static/images/hero_image_large-95f94a572bf72de2db3148a0c0523790.webp";